var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.paymentDueByCreditCard > 0)?_c('span',{staticClass:"total"},[_vm._v("\n  Total to pay\n  "),_c('Price',{attrs:{"value":_vm.paymentDueByCreditCard}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }